import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  width: 100%;
  background-color: transparent;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  z-index: 1000;
  transition: all 0.3s ease;

  &.hidden {
    transform: translateY(-100%);
    opacity: 0;
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const Logo = styled.img`
  height: 40px;
  width: auto;
  cursor: pointer;
`;

const Nav = styled.nav`
  display: flex;
  gap: 1rem;

  a {
    color: #ffffff;
    font-size: 1rem;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover {
      color: #cccccc;
    }
  }

  @media (max-width: 768px) {
    gap: 0.5rem;
    
    a {
      font-size: 0.9rem;
      padding: 0.5rem;
    }
  }
`;


const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSmoothScroll = (id) => {
    // For about us, check if we're on mobile or desktop
    if (id === 'about') {
      const isMobile = window.innerWidth <= 768;
      const targetId = isMobile ? 'about-mobile' : 'about';
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  };

  const handleLogoClick = () => {
    if (window.location.pathname === '/') {
      handleSmoothScroll('hero');
    } else {
      navigate('/#hero');
    }
  };

  return (
    <HeaderContainer className={scrolled ? 'hidden' : ''}>
      <Logo
        src="/images/Green logo no name.jpg"
        alt="NovaHomes Logo"
        onClick={handleLogoClick}
      />

      <Nav>
        <NavLink onClick={() => handleSmoothScroll('about')}>About Us</NavLink>
        <NavLink onClick={() => handleSmoothScroll('contact')}>Contact</NavLink>
      </Nav>
    </HeaderContainer>
  );
};

export default Header;